import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { usePlatformConfig } from '../../hooks/usePlatformConfig';
import { Translation } from '../Translation';
import previewModeBannerStyles from './previewModeBanner.styles';
const PreviewModeBanner = ({ translationId, }) => {
    const styles = previewModeBannerStyles();
    const { platformConfig: { themeOverride }, } = usePlatformConfig();
    const { dxpPreviewMode } = themeOverride || {};
    if (!dxpPreviewMode) {
        return null;
    }
    return (_jsx(Box, { className: styles.container, children: _jsx(Translation, { className: styles.title, id: translationId, component: "Typography", componentProps: { variant: 'h4' } }, void 0) }, void 0));
};
export default PreviewModeBanner;
//# sourceMappingURL=PreviewModeBanner.js.map